export default "__VITE_ASSET__CTk83Rpi__"